import React, { useEffect, useState } from "react";
import "./Styling.css";
import Duration from "./images/duration.png";

const WaitlistedUsers = ({ waitlist }) => {
  const isDataValid = Array.isArray(waitlist) && waitlist.length > 0;
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");

    if (!storedStart || !storedEnd) {
      setShowIcon(false);
      return;
    }

    const startDate = new Date(storedStart);
    const endDate = new Date(storedEnd);

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const isDefaultStart =
      startDate.getFullYear() === firstDayOfMonth.getFullYear() &&
      startDate.getMonth() === firstDayOfMonth.getMonth() &&
      startDate.getDate() === firstDayOfMonth.getDate();

    const isDefaultEnd =
      endDate.getFullYear() === today.getFullYear() &&
      endDate.getMonth() === today.getMonth() &&
      endDate.getDate() === today.getDate();

    setShowIcon(!(isDefaultStart && isDefaultEnd));
  }, []);
  return (
    <div className="waitlist-container">
      {showIcon && (
        <img src={Duration} alt="duration" className="duration-icon" />
      )}
      <h3 className="waitlist-title">Waitlisted Users</h3>
      <div className="table-wrapper">
        <table className="waitlist-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Signup Date</th>
            </tr>
          </thead>
          <tbody>
            {isDataValid ? (
              waitlist.map((user, idx) => (
                <tr key={idx}>
                  <td>{user?.email}</td>
                  <td>{user?.signup_date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="no-data-cell">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WaitlistedUsers;
